import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import { EditorialFlexModule } from "typings/microserviceModels/content-flex-module";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import RenderAbleContentItemExpando from "components/flexComponents/Content/factory/impl/items/RenderAbleContentItemExpando";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";

export class DestinationDescriptionEditorial extends EditorialBase {
  /* istanbul ignore next */
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const editorialModel = this.flexComponent.model as EditorialFlexModule;

    const classNameAttr = `${this.getEditorialItemClassName()}`;

    const {
      title: editorialTitle,
      subtitle: editorialSubtitle,
      text: editorialBody,
      id: editorialId,
    } = editorialModel.items[0];

    return (
      <div
        className={classNameAttr}
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
      >
        <div className="EditorialModuleTitle">
          {editorialTitle && (
            <UitkSpacing margin={{ block: "one" }}>
              <UitkHeading level={2} size={800}>
                {editorialTitle}
              </UitkHeading>
            </UitkSpacing>
          )}
          {editorialSubtitle && (
            <UitkSpacing margin={{ block: "one" }}>
              <UitkSubheading level={3}>{editorialSubtitle}</UitkSubheading>
            </UitkSpacing>
          )}
        </div>
        {editorialBody && (
          <UitkSpacing margin={{ block: "two" }}>
            <RenderAbleContentItemExpando id={editorialId} body={editorialBody} />
          </UitkSpacing>
        )}
      </div>
    );
  }
}

export default DestinationDescriptionEditorial;
